// extracted by mini-css-extract-plugin
module.exports =  {"tooltipBlock":"tooltipBlock__BHrY3"};